function initScrollProgress() {
  var wrapper = document.querySelector('[data-scroll-progress]');
  var circle = document.querySelector('[data-scroll-progress-circle]');
  if (!wrapper || !circle) return;

  var radius = circle.r.baseVal.value;
  var circumference = 2 * Math.PI * radius;
  circle.style.strokeDasharray = circumference;
  circle.style.strokeDashoffset = circumference;

  var ticking = false;

  function update() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;

    circle.style.strokeDashoffset = circumference * (1 - progress);
    wrapper.classList.toggle('is-visible', scrollTop > 80);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', update);
  update();
}

document.addEventListener('DOMContentLoaded', initScrollProgress);
